import { CustomIcon, IconLibrary, PaymentsIcon, SvgLibraryIcon, TailsIcon } from '@finnairoyj/fcom-ui-styles/enums';

export type IconName = IconSetProperties[keyof IconSetProperties]['name'];

export interface IconSetProperties {
  custom: {
    category: IconLibrary.CUSTOM;
    name: CustomIcon;
  };
  payments: {
    category: IconLibrary.PAYMENTS;
    name: PaymentsIcon;
  };
  svgLibrary: {
    category?: IconLibrary.SVG_LIBRARY;
    name: SvgLibraryIcon;
  };
  tails: {
    category: IconLibrary.TAILS;
    name: TailsIcon;
  };
}

export type IconSet =
  | IconSetProperties['custom']
  | IconSetProperties['payments']
  | IconSetProperties['svgLibrary']
  | IconSetProperties['tails'];

export enum IconSize {
  SMALL = 'icon-small',
  MEDIUM = 'icon-medium',
  LARGE = 'icon-large',
}
